module.exports = "/assets/data/80ee274da1140eb5d6174816ac05ed9e-HU6.data.json";